import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { WinterRadarOverlaySvgComponent } from './winter-radar-overlay-legend/winter-radar-overlay-legend-svg';

export const WINTER_RADAR_OVERLAY_LEGEND: TwcLegendParams = {
  title: 'RADAR MOSAIC',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: WinterRadarOverlaySvgComponent },
  legendComponent: TwcLegendComponent
};
